tpj.extend({
    adjustSearch: new function () {
        var self = this;
        var container;
        var $slider;
        var searching;

        self.initialize = function () {
            container = tpj('#adjust-search');

            attachBehaviour();

            self.searching = false;
            document.querySelectorAll('.replacement').forEach(function (a) {
                a.remove()
            })
        };

        self.filter = function (msg) {
            search(msg);
        };

        var search = function (msg) {
            if (!self.searching) {
                /* tpj.blockUI.defaults.css = {};
                 tpj.blockUI({ message: "<center><div class='blockUI-loader'></div></center><br/>" + msg });*/

                if (tpj("#is-favorites").length == 0) {
                    var dietRegimens = "";
                    tpj('.regimens input[type=checkbox]', container).each(function () {
                        if (tpj(this).is(':checked')) {
                            dietRegimens += tpj(this).val() + "|";
                        }
                    });

                    var payModes = "";
                    tpj('.payment-modes input[type=checkbox]', container).each(function () {
                        if (tpj(this).is(':checked')) {
                            payModes += tpj(this).val() + "|";
                        }
                    });



                    var facilities = "";
                    tpj('.facilities input[type=checkbox]', container).each(function () {
                        if (tpj(this).is(':checked')) {
                            facilities += tpj(this).val() + "|";
                        }
                    });

                    var canaryResident = false;
                    tpj('.canary-resident input[type=checkbox]', container).each(function () {
                        canaryResident = tpj(this).is(':checked');
                    });

                    var oneDietRegimen = tpj('.regimens #oneDietRegimen', container);
                    if (oneDietRegimen.length > 0) {
                        dietRegimens += oneDietRegimen.val() + "|";
                    }

                    var categories = "";
                    tpj('.categories input[type=checkbox]', container).each(function () {
                        if (tpj(this).is(':checked')) {
                            categories += tpj(this).val() + "|";
                        }
                    });

                    var oneCategory = tpj('.categories #oneCategory', container);
                    if (oneCategory.length) {
                        categories += oneCategory.val() + "|";
                    }

                    var serviceSubTypes = "";
                    tpj('.subtype2 input[type=checkbox]', container).each(function () {
                        if (tpj(this).is(':checked')) {
                            serviceSubTypes += tpj(this).val() + "|";
                        }
                    });

                    var oneSubType = tpj('.subtype2 #oneSubType', container);
                    if (oneSubType.length) {
                        serviceSubTypes += oneSubType.val() + "|";
                    }

                    var offerNameString = '';
                    var offerName = tpj("#offerName", container);
                    if (offerName.length) {
                        offerNameString = offerName.val();
                    }

                    var viewMode = tpj('.three-fourth article').attr("class");

                    var url = "public/get-adjust-search";
                    if (tpj('#filterAction').length > 0 && tpj('#filterController').length > 0) {
                        url = tpj('#filterController').val() + "/" + tpj('#filterAction').val();
                    }

                    self.searching = true;

                    var priceParts = [tpj("#minPrice", container).val(), tpj("#maxPrice", container).val()];

                    if (tpj("#Slider1").length > 0) {
                        var priceValues = tpj("#Slider1").val();

                        priceParts = priceValues.split(';');
                    }


                    var data = {
                        offerName: offerNameString,
                        minPrice: priceParts[0],
                        maxPrice: priceParts[1],
                        priceSortDir: tpj("#priceSortDir").val(),
                        dietRegimens: dietRegimens,
                        categories: categories,
                        serviceSubTypes: serviceSubTypes,
                        payModes: payModes,
                        facilities: facilities,
                        canaryResident: canaryResident
                    };

                    if (tpj('#zoneCode1').length > 0) {
                        data['zoneCode1'] = tpj('#zoneCode1').val();
                    }

                    if (tpj('#zoneCode2').length > 0) {
                        data['zoneCode2'] = tpj('#zoneCode2').val();
                    }

                    if (tpj('#zoneCode3').length > 0) {
                        data['zoneCode3'] = tpj('#zoneCode3').val();
                    }

                    if (tpj('#zoneCode4').length > 0) {
                        data['zoneCode4'] = tpj('#zoneCode4').val();
                    }

                    if (tpj('#categoryCode').length > 0) {
                        data['category'] = tpj('#categoryCode').val();
                    }

                    if (tpj('#equipamientoCode').length > 0) {
                        data['equipamiento'] = tpj('#equipamientoCode').val();
                    }

                    if (tpj('#term').length > 0) {
                        data['term'] = tpj('#term').val();
                    }

                    if (tpj('#filter-overlay').length == 0) {
                        var over = '<div id="filter-overlay" style="display:none">' +
							'<img id="loading" src="' + ASSETS_DOMAIN + '/Content/images/spinner.gif">' +
							'</div>';
                        tpj(over).appendTo('body');
                    }

                    tpj('#filter-overlay').css('height', tpj('body').height() + 'px').fadeIn();


                    tpj("#offers-list").heavyLoad(
                        url,
                        data,
                        function () {
                            tpj("#offers-list-count").html(tpj("#offer-list-hidden-count").val());
                            tpj('.num-results-place').text(tpj("#offer-list-hidden-count").val());
                            tpj('.three-fourth article').attr("class", viewMode);
                            tpj('.three-fourth article:nth-child(3n)').addClass("last");

                            attachPopoverEvents();

                            tpj(".socialItemDetails").click(function () {
                                tpj(this).next('.shareBox').toggle();
                                tpj(this).next('.shareBox').find('.sharemetoo').lazySocialButtons();
                            });

                            tpj('.results-breadcrumb').text(tpj("#offer-list-hidden-count").val());


                            self.searching = false;

                            //Actualizamos los codigos de hotel por si se hace la busqueda en estos hoteles
                            if (tpj('#serviceCodesFiltered').length > 0) {
                                tpj('#serviceCode').val(tpj('#serviceCodesFiltered').val());
                            } else {
                                tpj('#serviceCode').val("");
                            }
                            if (tpj('#hotelCountFiltered').length > 0) {
                                tpj('#hotel-count-title').text(tpj('#hotelCountFiltered').val());
                                if (tpj('#offer-list-hidden-count').val() != tpj('#hotelCountFiltered').val()) {
                                    tpj('#filtered-text-title').text("(filtrado...)");
                                } else {
                                    tpj('#filtered-text-title').text("");
                                }
                            }

                            tpj.offerList.refreshFilters(tpj('#Slider1').length > 0);

                            ////////////////////
                            var $wlist = jQuery('.listitem2').width();
                            var $hlist = jQuery('.listitem2').height();

                            jQuery('.liover').css({
                                "width": 10 + "%",
                                "height": 10 + "%",
                                "background-color": "#0099cc",
                                "position": "absolute",
                                "top": $hlist / 2 + "px",
                                "left": $wlist / 2 + "px",
                                "opacity": 0.0,
                            });
                            jQuery('.fav-icon').css({
                                "top": $hlist / 2 - 11 + "px",
                                "left": $wlist + "px",
                            });
                            jQuery('.book-icon').css({
                                "top": $hlist / 2 - 11 + "px",
                                "left": -25 + "px",
                            });

                            jQuery(".listitem2")
                                .mouseenter(function () {
                                    "use strict";
                                    jQuery(this).find('.liover').stop().animate({ "left": 10 + "%", "top": 10 + "%", "width": 80 + "%", "height": 80 + "%", "opacity": 0.5 });
                                    jQuery(this).find('.book-icon').stop().animate({ "left": $wlist / 2 - 42 + "px" });
                                    jQuery(this).find('.fav-icon').stop().animate({ "left": $wlist / 2 + 18 + "px" });


                                })
                                .mouseleave(function () {
                                    "use strict";
                                    jQuery(this).find('.liover').stop().animate({ "left": $wlist / 2 + "px", "top": $hlist / 2 + "px", "width": 10 + "%", "height": 10 + "%", "opacity": 0.0 });
                                    jQuery(this).find('.book-icon').stop().animate({ "left": -25 + "px" });
                                    jQuery(this).find('.fav-icon').stop().animate({ "left": $wlist + "px" });

                                });

                            ///////////////////////

                            var initFilters = "false";
                            if (tpj('#init-filters').length > 0) {
                                initFilters = tpj('#init-filters').val();
                            }

                            tpj.offerList.initialize(true, initFilters);

                            initThumbnailSlider();


                            initFeaturedHotel();
                            /*tpj.unblockUI();*/


                            //Reset map if already loaded
                            if (typeof(loadedMaps) != "undefined" && loadedMaps["all"]) {
                                loadedMaps["all"] = false;

                                //if map is visible, reload it
                                if (tpj('#map-all').css('display') == 'block') {
                                    loadMapAllHotels();
                                }
                            }

                            try {
                                //Init infinite scroll

                                tpj.scrollDav.init();
                            } catch (ex) {

                            }

                            tpj('#filter-overlay').fadeOut();

                            //Credit Calculator
                            if (typeof pmtSimulator !== typeof undefined && pmtSimulator && pmtSimulator.simulator_app && tpj('.PmtSimulator').length > 0) {
                                pmtSimulator.simulator_app.setPublicKey(PAGAMASTARDE_PUBLICKEY);
                                pmtSimulator.simulatorApp.restartSimulatorsArray();
                                pmtSimulator.simulator_app.init();
                            }
                            if (typeof icSimulator !== typeof undefined && icSimulator && tpj('.ic-simulator').length > 0) {
                                icSimulator.refresh();
                            }
                            if (typeof icLiteSimulator !== typeof undefined && icLiteSimulator && tpj('.ic-lite-simulator').length > 0) {
                                icLiteSimulator.refresh();
                            }

                        });
                }
                else {
                    tpj("#offers-list").heavyLoad("public/get-favorits", {
                        priceSortDir: tpj("#priceSortDir").val()
                    }, function () {
                        tpj("#offers-list-count").html(tpj("#offer-list-hidden-count").val());
                        /*tpj.unblockUI();*/
                    });
                }
            }
        };

        var clearFilters = function () {

            tpj('#adjust-search .checked input, #adjust-search input').attr('checked', false);
            tpj('#adjust-search .checked').removeClass('checked');

            tpj('#adjust-search input[type=text]').val("");

            if (tpj('#Slider1').length > 0) {

                tpj("#Slider1").val(tpj('#originalMinPrice').val() + ";" + tpj('#originalMaxPrice').val());

            }

            search("Ajustando busqueda...");
        };

        var attachBehaviour = function () {

            tpj('.filter-hotel-name-btn').click(function () {
                search("Ajustando busqueda...");
            })

            tpj("#offerName").keypress(function (event) {
                if (event.which == 13) {
                    //Enter
                    search("Ajustando busqueda...");
                }
            });

            tpj(".filter-btn", container).click(function () {
                search("Ajustando busqueda...");
            });

            tpj('.clear-filter-btn', container).click(function () {
                clearFilters();
            });

            tpj("#minPrice", container).numeric({ decimal: false, negative: false });
            tpj("#maxPrice", container).numeric({ decimal: false, negative: false });


            tpj('.priceSort').change(function () {
                tpj('#priceSortDir').val(tpj(this).val());
                search("Ordenando...");
            });


            tpj("input[type=checkbox]", container).click(function () {
                search("Ajustando busqueda...");
            });

            
        };
    }
});



